import { DashboardSummaryType } from "src/app/api/proxy/vitalscore/vitalscore-models";
export class DashboardDateSelectionType {
    public SelectionName: string = '';
    public FromDate: Date = new Date();
    public ToDate: Date = new Date();
    public SummaryType: DashboardSummaryType = DashboardSummaryType.Daily;  
}
